export const GuideSectionTypes = {
  JS: 'JS',
  TSX: 'TSX',
  SNIPPET: 'SNIPPET',
  SASS: 'SASS',
  STRING_JS: 'STRING_JS',
};
